import axios from "axios";
import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// USER ROLE MANAGEMENT RELATED APIs
// ==============================================

// 1. Get Role Design
export const getRoleDesign = async () => {
    try {
         // DEBUG
        
        const response = await axios.get(
            `${API_BASE_URL}/Accounts/GetRoleDesign`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 1b. Get Dashboard Type Departments (dropdown options for the role-creation form)
export const getDashboardTypeDepartments = async () => {
    try {
         // DEBUG

        const response = await axios.get(
            `${API_BASE_URL}/Accounts/GetDashboardTypeDepartments`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );

         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 2. Save New User Role (POST - for creating)
export const saveNewUserRole = async (roleData) => {
    try {

        const directPayload = {
            Action: roleData.businessRole.Action || 'Add',
            RoleName: roleData.businessRole.RoleName,
            Status: roleData.businessRole.Status,
            ApplicableForCC: roleData.businessRole.ApplicableForCC,
            ApplicableCCTypes: roleData.businessRole.ApplicableCCTypes || '',
            CheckCC: roleData.businessRole.CheckCC || 'No',
            DashboardTypeDepartmentId: roleData.businessRole.DashboardTypeDepartmentId || null,
            Createdby: roleData.businessRole.Createdby
        };
        
        
        const response = await axios.post(
            `${API_BASE_URL}/Accounts/SaveNewUserRole`,
            directPayload,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                timeout: 30000
            }
        );
        
        return response.data;
        
    } catch (error) {
        throw error.response?.data || error;
    }
};

// 3. Update User Role (PUT - for updating)
// 3. Update User Role (PUT - for updating) - Uses Form Data format
export const updateUserRole = async (roleData) => {
    try {
        
        // Extract direct fields from businessRole wrapper
        const directPayload = {
            Action: roleData.businessRole.Action || 'Update',
            UserRoleID: roleData.businessRole.UserRoleID,
            RoleName: roleData.businessRole.RoleName,
            Status: roleData.businessRole.Status,
            ApplicableForCC: roleData.businessRole.ApplicableForCC,
            ApplicableCCTypes: roleData.businessRole.ApplicableCCTypes || '',
            CheckCC: roleData.businessRole.CheckCC || 'No',
            DashboardTypeDepartmentId: roleData.businessRole.DashboardTypeDepartmentId || null,
            Createdby: roleData.businessRole.Createdby
        };


        const response = await axios.put(
            `${API_BASE_URL}/Accounts/UpdateUserRole`,
            directPayload,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                timeout: 30000
            }
        );
        
        return response.data;
        
    } catch (error) {
        throw error.response?.data || error;
    }
};
// 4. Get Verification Pending Role Design by Role ID
export const getVerificationPendingRoleDesign = async (roleId) => {
    try {
        
        const response = await axios.get(
            `${API_BASE_URL}/Accounts/GetVerificationPendingRoleDesign?Roleid=${roleId}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};